export const AdjustmentType = {
  SeasonalityAdjustment: 'SeasonalityAdjustment',
  DataExclusion: 'DataExclusion',
};

export function isDataExclusion(adjustmentType) {
  return adjustmentType === AdjustmentType.DataExclusion;
}